export {
  Video,
  ResponsiveVideo,
  type VideoProps,
  type ResponsiveVideoProps,
} from '../../compositions/shared/Video';
